module.exports = __webpack_public_path__ + "static/media/IMG_4267.8b670146.PNG";